import React, { useContext, useEffect } from 'react';
import { Button, IconButton, Icon, Typography, Chip } from '@material-ui/core';
import { icons } from 'asset';
import { ExchangesPageContext } from 'page/exchangeReport/index';

export default function FilterTab({
  type = '',
  defaultContext = ExchangesPageContext,
  showSearchButton = true,
  titleFilter = 'Filtro',
}) {
  const {
    scaleJsonInLocal,
    selectedUnit,
    stateScales,
    mainFilter,
    setMainFilter = () => {},
    handleOpenSearchModal = () => {},
    handleOpenFilter = () => {},
    handleCloseChipScale = () => {},
    handleCloseChipStatus = () => {},
  } = useContext(defaultContext);

  useEffect(() => {
    if (
      scaleJsonInLocal &&
      scaleJsonInLocal.length > 0 &&
      !mainFilter?.scale_id &&
      selectedUnit
    ) {
      const firstItem = scaleJsonInLocal[0];
      setMainFilter((old) => ({
        ...old,
        scale_id: firstItem.value,
        scale_name: firstItem.label,
      }));
    }
  }, [scaleJsonInLocal, mainFilter?.scale_id, selectedUnit, setMainFilter]);

  return (
    <div className="flex flex-nowrap w-full overflow-x-auto pb-2 whitespace-nowrap mt-3 mb-3 flex-col justify-start items-start">
      {showSearchButton && (
        <IconButton onClick={handleOpenSearchModal}>
          <Icon className="text-3xl">search</Icon>
        </IconButton>
      )}
      <Button
        id="btnFiltro"
        onClick={handleOpenFilter}
        startIcon={<img src={icons?.filter} className="w-8" />}
      >
        <Typography className="text-sm font-medium text-left">
          {titleFilter}
        </Typography>
      </Button>
      {type !== 'localScales' &&
        stateScales &&
        stateScales.length > 0 &&
        stateScales
          .filter((item) => item.checked)
          .map((option, i) => (
            <Chip
              key={i}
              className="ml-4"
              label={option.name}
              onDelete={handleCloseChipScale(option)}
            />
          ))}
      {type !== 'localScales' &&
        mainFilter &&
        mainFilter?.custom_filter &&
        mainFilter?.custom_filter
          .filter((item) => item.checked)
          .map((item) => (
            <Chip
              key={item.id}
              className="ml-4"
              label={item.name}
              onDelete={handleCloseChipStatus(item)}
            />
          ))}
      {type !== 'localScales' && mainFilter && mainFilter?.scale_id && (
        <Chip
          key={mainFilter?.scale_id}
          className="ml-4"
          label={mainFilter?.scale_name}
          onDelete={() =>
            setMainFilter((old) => ({
              ...old,
              scale_id: null,
              scale_name: null,
            }))
          }
        />
      )}
      <div className="flex flex-nowrap overflow-x-auto overflow-y-hidden whitespace-nowrap pl-2 gap-2 w-2/3 h-12">
        {scaleJsonInLocal &&
          scaleJsonInLocal.length > 0 &&
          selectedUnit &&
          scaleJsonInLocal
            .filter((item) => item.unit === selectedUnit.id)
            .map((option, i) => (
              <Chip
                key={i}
                className={`ml-4 shrink-0 ${
                  mainFilter.scale_id === option.value
                    ? 'bg-green-200 text-green-800'
                    : 'bg-gray-300'
                }`}
                style={
                  mainFilter.scale_id === option.value
                    ? {
                        marginLeft: 16,
                        backgroundColor:
                          mainFilter.scale_id === option.value
                            ? '#d1e7dd'
                            : '#d4d4d4', // Cor de fundo para selecionado
                        color:
                          mainFilter.scale_id === option.value
                            ? '#0f5132'
                            : 'inherit', // Cor do texto para selecionado
                      }
                    : {}
                } // Fallback style
                label={option.label}
                onClick={() =>
                  setMainFilter((old) => ({
                    ...old,
                    scale_id: option.value,
                  }))
                }
                onDelete={handleCloseChipScale(option)}
              />
            ))}
      </div>
    </div>
  );
}
